<template>
  <div class="main-content" :style="mainContentViewHeight">
    <div :style="{'height':(tableMaxHeight)+'px','overflow':'hidden'} ">
      <iframe :src="iframeUrl"  id="history2DArea" width="100%" style="margin-top: -56px" :height="tableMaxHeight + 55" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>

export default {
  props: ['mainContentViewHeight'],
  components: {

  },
  data() {
    return {
      url:"",
      tableMaxHeight: document.documentElement.clientHeight - 165 ,
      serverIp:"",
      iframeUrl:"",
    };
  },
  created() {
    this.getServerIp();
  },
  activated() {

  },
  methods: {
    getServerIp(){

      // 查询iframe Ip地址
      this.$httpReq.get('/document/sysPersonFaces/UWebUrl').then(res => {
        if (res.data.code === '1') {
          this.serverIp =res.data.data;
          // if(this.serverIp){
          //   this.iframeUrl = 'http://' + this.serverIp + "/EHCommon/MenuHistory/History2D/history2DCard"
          // }else{
          //   // http://192.168.1.59/EHCommon/MenuHistory/History2D/history2DCard
          //   this.iframeUrl = "http://192.168.1.59/EHCommon/MenuHistory/History2D/history2DCard"
          // }
          // FIXME 人员轨迹测试 替换图片
          this.iframeUrl = "http://172.16.26.190:30290/public/555DB7DAE20A4214B40955224065A901/202109/1632471277672001.png";

        }
      })

    }

  },
};
</script>
